<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
        <h5>Recuperación de Contraseña</h5>
    </div>
    <div class="header-right">
        <a class="btn txt-oscuro" href="javascript:void(0);" (click)="Cancelar()"><span title="Cancelar" class="far fa-times-circle"></span></a>
    </div>
</header>
<div class="container-fluid">
    
    <div class="d-flex align-items-center justify-content-center min-vh-100 bg-light p-3 ">

        <div class="card shadow-sm" style="max-width: 420px; width: 100%;">
            <div class="card-body">
                <div class="content-header">
                    @if(!passBoolean){
                    <h2>Recuperar password</h2>
                    }
                    @else {
                    <h2>Reestablecer password</h2>
                    }
                </div>
                @if (!passBoolean) {
                <form [formGroup]="formReestablecer" (submit)="enviarCorreo()">

                    <div class="row">
                        <div class="col">
                            <label for="inputUsuario" class="form-label">Usuario:</label>
                            <input formControlName="usuario"
                                [class.is-invalid]="formReestablecer.get('usuario')?.invalid && formReestablecer.get('usuario')?.touched"
                                type="text" class="form-control" id="inputUsuario">
                            @if (formReestablecer.get('usuario')?.errors && formReestablecer.get('usuario')?.touched) {
                            @if (formReestablecer.get('usuario')?.hasError('required')) {
                            <div class="invalid-feedback">
                                <span>El usuario es requerido</span>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col">
                            <button type="submit" class="btn btn-envio" [disabled]="loading">
                                @if (loading) {
                                <i class="fas fa-spinner fa-spin"></i>
                                }
                                Enviar correo
                            </button>
                        </div>
                    </div>
                </form>
                }
                @else {
                <form [formGroup]="formCambio" (submit)="cambioPass()">

                    <div class="row">
                        <div class="col">
                            <label for="inputUsuario" class="form-label">Contraseña:</label>
                            <input formControlName="pass"
                                [class.is-invalid]="formCambio.get('pass')?.invalid && formCambio.get('pass')?.touched"
                                type="password" class="form-control" id="inputUsuario">
                            @if (formCambio.get('pass')?.errors && formCambio.get('pass')?.touched) {
                            @if (formCambio.get('pass')?.hasError('required')) {
                            <div class="invalid-feedback">
                                <span>Valor requerido</span>
                            </div>
                            }
                            @if (formCambio.get('pass')?.hasError('pattern')){
                            <div class="invalid-feedback">
                                La contraseña debe tener al menos una mayúscula, una minúscula, un número y un carácter
                                especial.
                            </div>
                            }
                            @if (formCambio.get('pass')?.hasError('minlength') ){
                            <div class="invalid-feedback">
                                por lo menos 12 caracteres
                            </div>
                            }
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label for="inputUsuario" class="form-label">Validar Contraseña:</label>
                            <input formControlName="validarPass"
                                [class.is-invalid]="formCambio.get('validarPass')?.invalid && formCambio.get('validarPass')?.touched"
                                type="password" class="form-control" id="inputUsuario">
                            @if (formCambio.get('validarPass')?.errors && formCambio.get('validarPass')?.touched) {
                            @if (formCambio.get('validarPass')?.hasError('required')) {
                            <div class="invalid-feedback">
                                <span>Valor requerido</span>
                            </div>
                            }
                            @if (formCambio.get('validarPass')?.hasError('confirmedValidator')) {
                            <div class="invalid-feedback">
                                <span>No coinciden las contraseñas</span>
                            </div>
                            }
                            @if (formCambio.get('validarPass')?.hasError('pattern') ){
                            <div class="invalid-feedback">
                                La contraseña debe tener al menos una mayúscula, una minúscula, un número y un carácter
                                especial.
                            </div>
                            }
                            @if (formCambio.get('validarPass')?.hasError('minlength') ){
                            <div class="invalid-feedback">
                                por lo menos 12 caracteres
                            </div>
                            }
                            }
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col">
                            <button type="submit" class="btn btn-primary" [disabled]="loading">
                                @if (loading) {
                                <i class="fas fa-spinner fa-spin"></i>
                                }
                                Reestablecer contraseña
                            </button>
                        </div>
                    </div>
                </form>
                }
            </div>
        </div>

    </div>
</div>